<!-- Instagram Feed (desktop) -->
<div class="igp-window">
  <div class="igp igp-desktop">
    <div class="igp-header">
      <img class="igp-avatar" [src]="avatar" alt="" />
      <div class="igp-identity">
        <div class="igp-name">{{ accountName }}<i class="bi bi-patch-check-fill igp-verified"></i></div>
        <div class="igp-meta">Oglas</div>
      </div>
      <i class="bi bi-three-dots igp-menu"></i>
    </div>

    <a class="igp-link" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <app-meta-creative [src]="data.creative" [kind]="data.creativeKind" slot="feed"></app-meta-creative>
      <div class="igp-cta-row">
        <span>{{ cta }}</span>
        <i class="bi bi-chevron-right"></i>
      </div>
    </a>

    <div class="igp-actions">
      <i class="bi bi-heart"></i>
      <i class="bi bi-chat"></i>
      <i class="bi bi-arrow-repeat"></i>
      <i class="bi bi-send"></i>
      <i class="bi bi-bookmark igp-save"></i>
    </div>

    <div class="igp-caption">
      <span class="igp-caption-name">{{ accountName }}</span>
      {{ caption.text }}<span class="igp-caption-more" *ngIf="caption.truncated">... more</span>
    </div>
  </div>
</div>
